import $ from "jquery";

$(function () {
  /* Radiobuttons */
  $(document).on("change", ".gfield_radio input", function () {
    if ($(this).is(":checked")) {
      $(this).parent().addClass("__checked");
      $(this).parent().siblings().removeClass("__checked");
    }
  });

  /* Checkboxes */
  $(".gfield_radio input:checked").parent().addClass("__checked");

  $(document).on("change", ".gfield_checkbox input", function () {
    if ($(this).is(":checked")) {
      $(this).parent().addClass("__checked");
    } else {
      $(this).parent().removeClass("__checked");
    }
  });

  $(".gfield_checkbox input:checked").parent().addClass("__checked");

  /* Focus state */
  $(".gfield_radio input")
    .focus(function () {
      $(this).parent().addClass("__focused");
    })
    .blur(function () {
      $(this).parent().removeClass("__focused");
    });
  $(".gfield_checkbox input")
    .focus(function () {
      $(this).parent().addClass("__focused");
    })
    .blur(function () {
      $(this).parent().removeClass("__focused");
    });

  /* Consent checkbox */
  $(document).on("change", ".ginput_container_consent input", function () {
    if ($(this).is(":checked")) {
      $(this).parent().addClass("__checked");
    } else {
      $(this).parent().removeClass("__checked");
    }
  });

  // select
  $(".ginput_container_select select").each(function () {
    $(this).select2({
      selectionCssClass: "select2-css",
      minimumResultsForSearch: Infinity,
    });
  });

  // multi select
  const multiselect = $(".ginput_container_multiselect select");

  multiselect.each(function () {
    var selectId = $(this).parent();
    $(this).select2({
      selectionCssClass: "select2-css",
      dropdownParent: selectId,
    });
  });
});
